import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { fromQueryParamOr, toQueryParams } from '../_helpers/date-utils';
import { getDefaultDateFilters } from '../_helpers/default-params';

@Injectable()
export class FiltersGuard implements CanActivate {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const defaults = getDefaultDateFilters();
    const dateFrom = fromQueryParamOr(route.queryParams.dateFrom, defaults.dateFrom);
    const dateTo = fromQueryParamOr(route.queryParams.dateTo, defaults.dateTo);
    const queryParams = toQueryParams({ dateFrom, dateTo });

    if (route.queryParams.dateFrom === queryParams.dateFrom && route.queryParams.dateTo === queryParams.dateTo) {
      return true;
    }

    const url = state.url.split('?')[0];
    return this.router.createUrlTree([url], {
      relativeTo: this.activatedRoute,
      queryParams: toQueryParams({ dateFrom, dateTo }),
    });
  }
}
